import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    direction: PropTypes.oneOf(['left', 'right']),
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    direction: 'right',
    color: 'currentColor',
    className: null,
};

function CurvedArrowIcon({ direction, color, className }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="22"
            fill="none"
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <g
                style={{
                    transform: direction === 'left' ? 'rotate(180deg)' : null,
                    transformOrigin: 'center',
                    transition: '0.3s transform ease',
                }}
            >
                <path
                    fill={color}
                    d="M26.753 11.76c-1.154-.345-2.3-.718-3.465-1.033a33.193 33.193 0 0 0-13.753-.945c-2.11.317-4.174.893-6.143 1.716a1.402 1.402 0 0 1-1.708-.328 1.32 1.32 0 0 1-.122-1.635c.239-.296.547-.527.897-.675A28.71 28.71 0 0 1 9.19 7.001a38.437 38.437 0 0 1 18.59 2.185l.85.297c-.051-.245-.075-.4-.117-.548l-1.26-4.283a1.4 1.4 0 1 1 2.672-.772c.763 2.573 1.52 5.147 2.273 7.723a1.392 1.392 0 0 1-1.033 1.914c-2.59.77-5.182 1.532-7.776 2.288a1.397 1.397 0 0 1-1.892-1.478 1.395 1.395 0 0 1 1.107-1.19c1.372-.412 2.748-.808 4.122-1.212l.025-.16"
                />
            </g>
        </svg>
    );
}

CurvedArrowIcon.propTypes = propTypes;
CurvedArrowIcon.defaultProps = defaultProps;

export default CurvedArrowIcon;
